import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-badge-success',
  templateUrl: './badge-success.component.html',
  styleUrls: ['./badge-success.component.scss']
})
export class BadgeSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
